"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DensityResult = exports.DensityData = exports.DensityDataSample = void 0;
class DensityDataSample {
    constructor(raw) {
        this.code = raw.code;
        this.name = raw.name || '';
        this.value = +raw.value;
        this.rank = raw.rank !== undefined ? +raw.rank : null;
    }
}
exports.DensityDataSample = DensityDataSample;
class DensityData {
    constructor(raw) {
        this.average = +raw.average;
        this.max = +raw.max;
        this.min = +raw.min;
        this.percentil_05 = +raw.percentil_05;
        this.percentil_025 = +raw.percentil_025;
        this.percentil_075 = +raw.percentil_075;
        this.num_samples = +raw.present_in_num_samples;
        this.samples = raw.samples.map((s) => new DensityDataSample(s));
    }
}
exports.DensityData = DensityData;
class DensityResult {
    constructor(cluster, density_raw) {
        this.cluster = cluster;
        this.density = new DensityData(density_raw);
    }
}
exports.DensityResult = DensityResult;
